import { Pipe, PipeTransform, inject } from '@angular/core';

import { Label } from '@dibsondance/shared-types';

import { AppLanguage, I18nHelper } from '../i18n.helper';

@Pipe({
  name: 'libLabel',
  standalone: false,
  pure: false,
})
export class LabelPipe implements PipeTransform {
  private readonly i18nHelper = inject(I18nHelper);

  transform(label: Label, currentLanguage?: AppLanguage): string {
    const lang = currentLanguage ?? this.i18nHelper.currentLang();
    return label.i18n[I18nHelper.appLanguageToSystem(lang)];
  }
}
